var React = require('react');

function DeliveryInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1 10)","stroke":"currentColor","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round"},[React.createElement("path",{"d":"M42 7.793h9.252a2 2 0 011.312.49l8.748 7.602a2 2 0 01.688 1.51v17.553h0-20V7.793z","key":0}),React.createElement("circle",{"cx":"14.5","cy":"39.5","r":"4.5","key":1}),React.createElement("circle",{"cx":"49.5","cy":"39.5","r":"4.5","key":2}),React.createElement("path",{"d":"M3 13.788V3.182C3 1.909 3.803 0 5 0h35c1.197 0 2 1.91 2 3.182V35H5c-1.197 0-2-.849-2-2.121v-8.485M0 15h19M42 18h19M23 15h2M47 23h2","key":3})]));
}

DeliveryInline.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = DeliveryInline;

DeliveryInline.default = DeliveryInline;
